module.exports = __webpack_public_path__ + "img/40_70_001_486.563cc3a9.jpg";